export default __webpack_public_path__ + "static/media/bold.dce7d9f9.svg";